// extracted by mini-css-extract-plugin
export default {"previewerContainer":"XFnOZKLEaWGMnuS5_kLJ","optionsContainer":"mrXM_wFefZHUoV3Fi5pj","desktop":"H7Ve2FppMbSLIFk6VRba","tablet":"OKmMyhaAvevBa36GOTfR","mobile":"gQFHQOog4uA5CR_nya2E"};